import Vue from 'vue'
import { USER_INFO, ENHANCE_PRE, SET_SITE,ALL_SET_SITE, SET_LANGUAGE, SET_NUMBER_TYPE_OPTIONS } from "@/store/mutation-types"
const getters = {
  language:state => {state.app.language = Vue.ls.get(SET_LANGUAGE); return state.app.language},
  siteInfo:state => {state.user.siteInfo = Vue.ls.get(SET_SITE) && Vue.ls.get(SET_SITE); return state.user.siteInfo},
  allSiteInfo:state => {state.user.siteInfo = Vue.ls.get(ALL_SET_SITE) && Vue.ls.get(ALL_SET_SITE); return state.user.siteInfo},
  numberTypeOptions:state => {state.user.numberTypeOptions = Vue.ls.get(SET_NUMBER_TYPE_OPTIONS) && Vue.ls.get(SET_NUMBER_TYPE_OPTIONS); return state.user.numberTypeOptions},
  device: state => state.app.device,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  avatar: state => {state.user.avatar = Vue.ls.get(USER_INFO).avatar; return state.user.avatar},
  username: state => {state.user.info.username =  Vue.ls.get(USER_INFO) && Vue.ls.get(USER_INFO).username; return state.user.info.username},
  nickname: state => {state.user.info.realname =  Vue.ls.get(USER_INFO) && Vue.ls.get(USER_INFO).realname; return state.user.info.realname},
  userId: state => {state.user.info.realname =  Vue.ls.get(USER_INFO) && Vue.ls.get(USER_INFO).id; return state.user.info.id},
  welcome: state => state.user.welcome,
  permissionList: state => state.user.permissionList,
  userInfo: state => {state.user.info = Vue.ls.get(USER_INFO); return state.user.info},
  addRouters: state => state.permission.addRouters,
  onlAuthFields: state => {return state.online.authFields },
  enhanceJs:(state) => (code) => {
    state.enhance.enhanceJs[code] = Vue.ls.get(ENHANCE_PRE+code);
    return state.enhance.enhanceJs[code]
  },
  sysSafeMode: state => state.user.sysSafeMode,

}

export default getters
